/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllowedBillingCyclesQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AllowedBillingCyclesQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly allowedBillingCycles: ReadonlyArray<GraphQL.Term> } | null };


export const AllowedBillingCyclesDocument = gql`
    query AllowedBillingCycles($accountId: AccountId!) {
  account(id: $accountId) {
    id
    allowedBillingCycles
  }
}
    `;

/**
 * __useAllowedBillingCyclesQuery__
 *
 * To run a query within a React component, call `useAllowedBillingCyclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowedBillingCyclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowedBillingCyclesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAllowedBillingCyclesQuery(baseOptions: Apollo.QueryHookOptions<AllowedBillingCyclesQuery, AllowedBillingCyclesQueryVariables> & ({ variables: AllowedBillingCyclesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllowedBillingCyclesQuery, AllowedBillingCyclesQueryVariables>(AllowedBillingCyclesDocument, options);
      }
export function useAllowedBillingCyclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllowedBillingCyclesQuery, AllowedBillingCyclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllowedBillingCyclesQuery, AllowedBillingCyclesQueryVariables>(AllowedBillingCyclesDocument, options);
        }
export function useAllowedBillingCyclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllowedBillingCyclesQuery, AllowedBillingCyclesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllowedBillingCyclesQuery, AllowedBillingCyclesQueryVariables>(AllowedBillingCyclesDocument, options);
        }
export type AllowedBillingCyclesQueryHookResult = ReturnType<typeof useAllowedBillingCyclesQuery>;
export type AllowedBillingCyclesLazyQueryHookResult = ReturnType<typeof useAllowedBillingCyclesLazyQuery>;
export type AllowedBillingCyclesSuspenseQueryHookResult = ReturnType<typeof useAllowedBillingCyclesSuspenseQuery>;
export type AllowedBillingCyclesQueryResult = Apollo.QueryResult<AllowedBillingCyclesQuery, AllowedBillingCyclesQueryVariables>;